export default {
    outline: {
        name: "Outline",
        url: "nwcg_polygons_reference/outline",
    },
}
